<script setup lang=ts>
import {
  OrButtonV3,
} from '@onereach/ui-components';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import config from '@/config';
import { useAuthStore } from '@/stores/auth/auth';

import LoginContainer from '../layouts/LoginContainer.vue';

const router = useRouter();
const authStore = useAuthStore();

const loading = ref(false);

const loadUsers = async () => {
  await authStore.loadUsers();
};

const availableUsers = computed(() => authStore.availableUsers);

const isMultipleUser = computed(() => availableUsers.value.length > 1);


const logoutUrl = computed(() => {
  const encodedRedirectPath = encodeURIComponent(`${window.location.origin}/#/`);
  return `${config.AUTH_UI_URL}/logout?redirectPath=${encodedRedirectPath}`;
});


const logout = () => {
  window.parent.location.href = logoutUrl.value;
};

const listUsers = () => {
  router.push('/multi-user/list-users?fromExpired');
};

onMounted(async () => {
  if (!availableUsers.value.length) {
    loading.value = true;
    await loadUsers();
    loading.value = false;
  }
});
</script>

<template>
  <LoginContainer
    ref="cookieExpireModal"
    class="relogin-modal"
    :background="true"
  >
    <div
      class="reload-form px-md sm:px-0 layout-column items-center w-full sm:w-[340px] md:w-[290px]"
    >
      <div class="typography-headline-2 mb-sm text-center">
        {{ $t('session_expire.Permission denied') }}
      </div>
      <div class="typography-body-2-regular dark:text-outline-dark text-center mb-sm+">
        {{ $t('session_expire.You have no access') }}
      </div>
      <div
        class="button-wrapper w-full sm:px-0 layout-column justify-between sm:items-center"
      >
        <OrButtonV3
          v-if="isMultipleUser"
          :loading="loading"
          class="reload flex-1 sm:flex-auto"
          @click="listUsers"
        >
          {{ $t('session_expire.Switch account') }}
        </OrButtonV3>
        <OrButtonV3
          v-else
          :loading="loading"
          class="reload flex-1"
          variant="outlined"
          @click="logout"
        >
          {{ $t('session_expire.Sign out') }}
        </OrButtonV3>
      </div>
    </div>
  </LoginContainer>
</template>
